import { Form, Formik } from "formik";
import { PMButton } from "../../utils/PMButton";
import { PMField } from "../../utils/PMField";
import PMSwitch from "../../utils/PMSwitch";
import { PMNotice } from "../../utils/notifications";
import { PMDialog } from "../../utils/PMDialog";
import { dispatchWithToast } from "../../Utils";
import { updateHourAsync } from "../../../slices/hour";
import { useDispatch } from "react-redux";
import * as Yup from "yup";
import { useState } from "react";
import { HistoriesModalButton } from "../histories/modal-button";

export const ApproveHourDialog = ({ hour, onRefresh, open, onClose }) => {
  const dispatch = useDispatch();

  const [errors, setErrors] = useState([]);

  const dialogHeaderActions = [
    {
      component: (
        <HistoriesModalButton module={"hour_process"} module_param={hour?.id} />
      ),
      action: () => onClose(),
      color: "text-gray-500",
    },
  ];

  return (
    <PMDialog
      title="Behandle time"
      open={open}
      onClose={onClose}
      headerActions={dialogHeaderActions}
    >
      <Formik
        enableReinitialize={false} // Disable automatic reinitialization
        initialValues={{
          id: hour?.id,
          process: true,
          approved: hour?.approved,
          not_approved: hour?.not_approved,
          processed: hour?.processed,
          process_note: hour?.process_note,
        }} // Use the separate initialValues state
        validationSchema={Yup.object({
          description: Yup.string(),
        })}
        onSubmit={(values, helpers) => {
          console.log("values", values);
          dispatchWithToast(
            dispatch(updateHourAsync(values)),
            (data) => {
              // onRefresh(data); // Update hour state
              helpers.setStatus({ success: true });
              helpers.setSubmitting(false);
              if (typeof onRefresh === "function") {
                onRefresh(data);
              }
              onClose();
            },
            () => {
              helpers.setSubmitting(false); // Ensure submitting state is reset
              // Do not close here; already handled on success
            }
          );
        }}
      >
        {(formik) => (
          <Form>
            {errors &&
              errors.length > 0 &&
              errors.map((error, index) => (
                <PMNotice
                  severity={"error"}
                  key={index}
                  title="Error!"
                  description={error}
                />
              ))}

            <div className="grid grid-cols-2 sm:grid-cols-2 gap-6">
              <div className="col-span-1 sm:col-span-1">
                <PMSwitch
                  label="Godkjent"
                  name="approved"
                  onChange={(e) => {
                    formik.setFieldValue("not_approved", false);
                    formik.handleChange(e);
                  }}
                  {...formik}
                />
              </div>

              <div className="col-span-1 sm:col-span-1">
                <PMSwitch
                  label="Ikke godkjent"
                  name="not_approved"
                  onChange={(e) => {
                    formik.setFieldValue("approved", false);
                    formik.handleChange(e);
                  }}
                  {...formik}
                />
              </div>

              <div className="col-span-2 sm:col-span-2">
                <PMField
                  label="Notat"
                  name="process_note"
                  multiline={true}
                  rows={2}
                  {...formik}
                />
              </div>

              <div className="col-span-2 sm:col-span-2 flex justify-between">
                <PMButton
                  type="button"
                  onClick={() => onClose()}
                  className="bg-slate-400 hover:bg-slate-200 hover-bg- max-w-1/2"
                >
                  Avbryt
                </PMButton>
                <PMButton className="ml-10 max-w-1/2" type="submit">
                  Lagre
                </PMButton>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </PMDialog>
  );
};
